import {Point} from '@mintdata/mint-kit/api/models/Point';

export class PageInfo
{
    constructor(public pageOffset:Point)
    {
    }
}
